import { StoresList } from '@ui/store/stores-list';
import { useProductsStores } from '../../../entites/store/products-stores.ts';

export const ProductStores = ({ productId }: { productId: number }) => {
  const { data } = useProductsStores({ productId });

  return <StoresList items={data} />;
};
